export default __webpack_public_path__ + "static/media/hemalatha-ramanagar.ae743afc.jpg";